<template>
    <v-app>

        <router-view></router-view>

    </v-app>

</template>

<script>

    export default {

        data() {
            return {
                clipped: false,
                drawer: true,
                fixed: false,
                miniVariant: false,
                right: true,
                rightDrawer: false,
                title: 'MIS & Accounting Software'
            }
        },
        mounted: function () {
            //this.removeTinyMceMessage();
        },
        methods: {
            removeTinyMceMessage: function () {
                setTimeout(function () {
                    var mceNotificationInner = document.getElementsByClassName('mce-notification-inner');
                    for (var i = 0; i < mceNotificationInner.length; i++) {
                        mceNotificationInner[i].classList.remove('mce-notification-inner');
                        mceNotificationInner[i].classList.remove('mce-notification-warning');
                    }
                }, 20000);
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/App.vue